import React from 'react';
import SavedCardsList from './SavedCardsList';
import { getUsersSavedCards, deleteUserSavedCards } from '../../../actionCreators/savedCards';
import './SavedCards.scss';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BlankLoader from '../Common/BlankLoader';
import BootstrapSuccessError from './BootstrapSuccessError';

class SavedCards extends React.PureComponent {
  static propTypes = {
    savedCardDelete: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    props.getUsersSavedCards();
    this.deleteUserCard = this.deleteUserCard.bind(this);
  }

  deleteUserCard(cardToken, emailId) {
    emailId = encodeURIComponent(emailId);
    const { deleteUserSavedCards } = this.props;
    deleteUserSavedCards(cardToken, emailId);
  }

  render() {
    const {
      usersSavedCardsList,
      loading,
      userInfo,
      savedCardDelete,
      error,
      deleteSaveCardFail,
      dataLocale,
    } = this.props;
    const userEmail = userInfo && userInfo.email ? userInfo.email : '';
    const {
      YOUR_SAVED_CARDS,
      SAVED_CARDS,
      SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN,
      SUCCESSFULLY_DELETED_YOUR_CARD,
      YOU_DONT_HAVE_SAVED_CARDS,
    } = dataLocale;
    return (
      <React.Fragment>
        <Helmet title={SAVED_CARDS} />
        <h2 className="allSavedCards padding-l15">{YOUR_SAVED_CARDS}</h2>
        {loading ? (
          <BlankLoader imageStyle={{}} style={{}} />
        ) : (
          <React.Fragment>
            {error && (
              <BootstrapSuccessError
                message={SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN}
                timeout={deleteSaveCardFail ? '' : 'false'}
                type="error"
              />
            )}
            {savedCardDelete && (
              <BootstrapSuccessError message={SUCCESSFULLY_DELETED_YOUR_CARD} type="success" />
            )}
            {usersSavedCardsList &&
              (usersSavedCardsList.result.savedCards.length ? (
                <SavedCardsList
                  dataLocale={dataLocale}
                  deleteUserCard={this.deleteUserCard}
                  userEmail={userEmail}
                  usersSavedCardsList={usersSavedCardsList.result.savedCards}
                />
              ) : (
                <BootstrapSuccessError
                  message={YOU_DONT_HAVE_SAVED_CARDS}
                  timeout="false"
                  type="warning"
                />
              ))}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    usersSavedCardsList: state.savedCards.getUsersSavedCards,
    loading: state.savedCards.loading,
    savedCardDelete: state.savedCards.savedCardDelete,
    userInfo: state.common.userInfo.result,
    error: state.savedCards.error,
    deleteSaveCardFail: state.savedCards.deleteSaveCardFail,
    dataLocale: state.locale,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getUsersSavedCards: () => dispatch(getUsersSavedCards('PU')),
    deleteUserSavedCards: (cardToken, emailId) =>
      dispatch(deleteUserSavedCards(cardToken, emailId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SavedCards);
